document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.innerWidth < 768;
  if (!isMobile) return;

  const sections = document.querySelectorAll('.zendesk-tab-section');
  if (!sections.length) return;

  sections.forEach(initAccordionForSection);

  function initAccordionForSection(section) {
    const tabsWrapper = section.querySelector('.oxy-tabs-wrapper');
    const tabHeaders = tabsWrapper?.querySelectorAll('.oxy-tab');
    const tabContentsWrapper = section.querySelector('.oxy-tabs-contents-wrapper');
    const tabContents = tabContentsWrapper?.querySelectorAll('.oxy-tab-content');

    if (!tabsWrapper || !tabHeaders?.length || !tabContents?.length) return;

    tabsWrapper.style.display = 'none';

    const accordionContainer = document.createElement('div');
    accordionContainer.className = 'mobile-accordion-wrapper';

    tabHeaders.forEach((tab, i) => {
      const accordionItem = createAccordionItem(tab.innerText.trim(), tabContents[i]);
      accordionContainer.appendChild(accordionItem);
    });

    tabsWrapper.parentNode.insertBefore(accordionContainer, tabsWrapper);
    openFirstAccordionItem(accordionContainer);
  }

  function createAccordionItem(title, content) {
    const item = document.createElement('div');
    item.className = 'accordion-item';

    const header = document.createElement('button');
    header.className = 'accordion-header';
    header.textContent = title;
    header.setAttribute('aria-expanded', 'false');

    const contentWrapper = document.createElement('div');
    contentWrapper.className = 'accordion-content';
    if (content) contentWrapper.appendChild(content);

    header.addEventListener('click', () => handleAccordionClick(item, header));

    item.appendChild(header);
    item.appendChild(contentWrapper);

    return item;
  }

  function handleAccordionClick(item, header) {
    const container = item.parentNode;
    const isOpen = item.classList.contains('active');

    container.querySelectorAll('.accordion-item').forEach(el => {
      el.classList.remove('active');
      el.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'false');
    });

    if (!isOpen) {
      item.classList.add('active');
      header.setAttribute('aria-expanded', 'true');
    }
  }

  function openFirstAccordionItem(container) {
    const firstItem = container.querySelector('.accordion-item');
    if (!firstItem) return;

    firstItem.classList.add('active');
    firstItem.querySelector('.accordion-header')?.setAttribute('aria-expanded', 'true');
  }
});
